import React, { useState, useMemo } from "react";
import ReusableTable from "../../components/common/Table.tsx";
import { IconButton } from "@mui/material";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import {
    type MRT_ColumnDef,
    type MRT_PaginationState,
} from "material-react-table";
import { useNavigate } from "react-router-dom";
import { GetBatchPredictionResult } from "../../modules/predictorModule.ts";
import {toast, ToastContainer} from 'react-toastify';import StatusBadge from "../../components/common/Badge.tsx";

interface Predictions {
    prediction_id: number;
    train_id: number;
    dataset_id: number;
    predictor_name: string;
    predictor_type: string;
    prediction_type: string;
    status: string;
    no_of_records: number;
    problem_type: string;
}

const RecentPredictions = ({ predictions, predictor }) => {
    const navigate = useNavigate();
    const [totalRows, setTotalRows] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [pagination, setPagination] = useState<MRT_PaginationState>({
        pageIndex: 0,
        pageSize: 10,
    });
    const [anchorEl, setAnchorEl] = useState<{
        [key: number]: HTMLElement | null;
    }>({});
    const getProblemDisplayName = (problem_type: string): string => {
        const problemTypeMapping: { [key: string]: string } = {
            "Classification": "Classification",
            "Forecast": "Forecast",
            "Regression": "Regression",
            "UnsupervisedLearning": "Unsupervised Learning"
        };

        return problemTypeMapping[problem_type] || problem_type;
    };
    //const toast = useToast();

    const handleViewClick = async (
        event: React.MouseEvent<HTMLButtonElement>,
        prediction_id: number,
        train_id: number
    ) => {
        try {
            setIsLoading(true);
            const response = await GetBatchPredictionResult(prediction_id);
            if (response) {
                navigate('/batch-prediction-view', { state: { BatchData: response, train_id: train_id, predictor: predictor } })
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.detail || "Failed to view batch prediction result";
            toast.error(errorMessage);
        } finally {
            setIsLoading(false);
        }
    };

    const columns = useMemo<MRT_ColumnDef<Predictions>[]>(
        () => [
            {
                accessorKey: "predictor_name",
                header: "Predictor Name",
            },
            {
                accessorKey: "problem_type",
                header: "Predictor Type",
                Cell: ({ row }) => {
                    return getProblemDisplayName(row.original.problem_type);
                }
            },
            {
                accessorKey: "status",
                header: "Prediction Status",
                Cell: ({ row }) => {
                    return  row?.original?.status ? <StatusBadge value={row?.original?.status} isCustomerTag={false} /> : "-";
                }
            },
            {
                accessorKey: "no_of_records",
                header: "No. of Records",
            },
            {
                accessorKey: "actions",
                header: "Actions",
                enableSorting: false,
                enableColumnFilter: false,
                size: 100,
                Cell: ({ row }) => (
                    <IconButton className="text-black-500" onClick={(e) => handleViewClick(e, row.original.prediction_id, row.original.train_id)} disabled={row.original.status !== "Completed"} >
                        <VisibilityOutlinedIcon />
                    </IconButton>
                ),
            },
        ],
        [anchorEl]
    );

    return (
        <div className="container-fluid px-0">
            <div className="disable-margin-card table-responsive table-customer border table-border w-100">
                <ReusableTable
                    columns={columns}
                    data={predictions}
                    pagination={pagination}
                    onPaginationChange={setPagination}
                />
            </div>
        </div>
    );
};

export default RecentPredictions;
